export default function Footer() {
  return (
    <footer className="bg-accent-900 text-accent-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-lg">🍉</span>
              <span className="font-heading text-lg text-accent-50">校园吃瓜</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-accent-200">
              主打轻松向的校园闲聊围观社区，汇集校园吃瓜段子与趣味日常趣事。
              下课没事来围观，看看别人班又在整什么活，边吃瓜边找同好一起乐。
            </p>
            <p className="mt-4 text-xs text-accent-300/80">
              倡导友善围观 · 快乐第一 · 不开不友善的玩笑
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-accent-50">快速围观</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {[
                { href: "#hot", label: "今日热榜" },
                { href: "#categories", label: "吃瓜分类" },
                { href: "#feed", label: "围观广场" },
                { href: "#poll", label: "话题投票" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-accent-200 hover:text-accent-50 transition-colors whitespace-nowrap">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-accent-50">了解更多</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {[
                { href: "#about", label: "关于我们" },
                { href: "#faq", label: "常见问题" },
                { href: "#submit", label: "我要投稿" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-accent-200 hover:text-accent-50 transition-colors whitespace-nowrap">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-accent-800 pt-6">
          <p className="text-xs text-accent-300 whitespace-nowrap">
            © {new Date().getFullYear()} 校园吃瓜 · 让校园日常更有乐
          </p>
          <p className="text-xs text-accent-300/80 whitespace-nowrap">
            本网站内容仅供娱乐，请友善围观，注意保护个人隐私
          </p>
        </div>
      </div>
    </footer>
  );
}